import { z } from "zod";

/**
 * Aceita um ou mais emails separados por pipe "|", validando cada parte.
 * Ex.: "a@x.com | b@y.com"
 *
 * O backend faz o mesmo split por "|" ao montar os destinatários do fechamento
 * (gestorEntregoFechamento / gestorImileFechamento), então o formato tem que
 * bater. Vive aqui porque é usado pelos cadastros de franquia do entrego e da
 * iMile — era a única coisa que valia compartilhar entre as duas telas.
 */
export const pipeSeparatedEmails = z
  .string()
  .min(1, "Email de Contato é obrigatório")
  .refine(
    (val) => {
      const emails = val
        .split("|")
        .map((e) => e.trim())
        .filter(Boolean);
      return (
        emails.length > 0 &&
        emails.every((e) => z.string().email().safeParse(e).success)
      );
    },
    {
      message: "Informe um ou mais emails válidos separados por | (pipe)",
    }
  );
